import React, { useEffect, useState } from 'react'
import { GlobalDataState } from '../../../Context'
import {Link} from "react-router-dom"
const Search = () => {
    const [dataSearched,setSearchedData]=useState([]);
    const {textSearch,setClickedId}=GlobalDataState();
    //console.log(textSearch)
   // https://api.themoviedb.org/3/search/movie?api_key=95827c3fee6b7922a023ac65e529dca2&query=batman
   useEffect(()=>{
          getSearchedData()
   },[textSearch])
   
   async function getSearchedData(){
    const data=await fetch(`https://api.themoviedb.org/3/search/movie?api_key=95827c3fee6b7922a023ac65e529dca2&query=${textSearch}`)
    const json=await data.json();
    setSearchedData(json.results);
   }


  return (
    <div>
        <div style={{margin:"7rem"}}>
                {
            Object.values(dataSearched).map((idx)=>(
                <Link to={"/moviesdetails"} style={{textDecoration:'none',color:'inherit'}}>
                <div onClick={()=>setClickedId(idx.id)}>
                <div style={{display:'flex',borderRadius:'1rem',boxShadow:"0 0 0 2px gray",width:"75%",marginBottom:'2rem'}}>
                    <div>
                    <img style={{width:'10rem',borderTopLeftRadius:'1rem',borderBottomLeftRadius:'1rem',height:'14rem',display:'block'}} src={`https://image.tmdb.org/t/p/w500/${idx.poster_path}`}></img>
                    </div>
                    <div style={{marginLeft:'2rem'}}>
                        <div style={{fontSize:"1.5rem",fontWeight:'bolder'}}>{idx.title}</div>
                        <div style={{display:'flex' ,gap:'2rem'}}>
                        <div>{idx.vote_average}</div>
                        <div>{idx.release_date}</div>
                        </div>
                        <div style={{marginTop:'2rem'}}><p>{idx.overview}</p></div>
                    </div>
                </div>
                </div>
                </Link>
            ))
            }
            </div>
    </div>
  )
}

export default Search